import { detectFileType } from "@aichat/aichat-lib";
import { MediaType } from "@aichat/types/enums/index";
import { MediaComponent as TMediaComponent } from "@aichat/types/socket/widget.types";
import { useEffect, useState } from "react";
import ImagePreview from "./image-preview";
import VideoPreview from "./video-preview";
import YoutubePreview from "./youtube-preview";
import { cn } from "@aichat/ui/lib/utils";

type MediaComponentProps = {
  medias: TMediaComponent[];
  isUser?: boolean;
  type?: "portal-chat" | "widget-chat";
};
function MediaComponent({ medias, type, isUser }: MediaComponentProps) {
  return (
    <div
      className={cn("flex flex-col gap-2 my-2", {
        "items-end": type === "portal-chat" && !isUser,
      })}
    >
      {medias.map((media, index) => (
        <Media key={index} media={media} />
      ))}
    </div>
  );
}

export default MediaComponent;

const Media = ({ media }: { media: TMediaComponent }) => {
  const [mediaType, setMediaType] = useState(MediaType.UNKNOWN);
  useEffect(() => {
    const getMediaType = async () => {
      const mediaTypeRes = await detectFileType(media.url);
      if (mediaTypeRes !== mediaType) {
        setMediaType(mediaTypeRes);
      }
    };
    getMediaType();
  }, [media.url]);

  if (!media.url) return;
  return (
    <div className="p-[2px] w-fit max-w-[374px] rounded-xl bg-background border border-border shadow-[0px_1px_2px_0px_#0000000D]">
      {mediaType === MediaType.IMAGE && (
        <ImagePreview url={media.url} alt_text={media.alt_text} />
      )}
      {mediaType === MediaType.VIDEO && <VideoPreview url={media.url} />}
      {mediaType === MediaType.YOUTUBE_VIDEO && (
        <YoutubePreview url={media.url} />
      )}
    </div>
  );
};
